import { render, staticRenderFns } from "./f-icon.vue?vue&type=template&id=2024a848&"
import script from "./f-icon.vue?vue&type=script&lang=js&"
export * from "./f-icon.vue?vue&type=script&lang=js&"
import style0 from "./f-icon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports